import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';

/**
 * inspect-world-object-offsets
 * Used with "inspect-world-object" component to offset rotations
 * Splitted properties here for easier management
 */
export class InspectWorldObjectOffsets extends Component {
    static TypeName = 'inspect-world-object-offsets';

    @property.enum(['0,0,1', '0,1,0', '1,0,0'], '0,0,1')
    rotateObjAxis = 0;

    @property.float(0)
    textObjRotOffsetX = 0;
    @property.float(0)
    textObjRotOffsetY = 0;
    @property.float(0)
    textObjRotOffsetZ = 0;
    @property.float(1.3)
    textObjDistance = 1.3;
    @property.float(0.3)
    textObjHeight = 0.3;
    @property.float(1.3)
    inspectedObjDistance = 1.3;
    @property.float(0)
    inspectedObjRotOffsetX = 0;
    @property.float(0)
    inspectedObjRotOffsetY = 0;
    @property.float(0)
    inspectedObjRotOffsetZ = 0;

    /**
     * Returns the axis of rotation for the object.
     * @returns An array representing the axis of rotation for the object.
     */
    getRotateObjAxis(): vec3 {
        const axis = [
            [0, 0, 1],
            [0, 1, 0],
            [1, 0, 0],
        ][this.rotateObjAxis];
        if (!axis) {
            console.warn(
                'inspect-world-object-offsets: Invalid axis index',
                this.rotateObjAxis
            );
            return [0, 0, 1];
        }
        return axis as vec3;
    }
}
